import * as React from 'react';
import { Paperclip, Trash2 } from 'lucide-react';
import type { DocumentGridProps } from '@/types';

export const DocumentGrid: React.FC<DocumentGridProps> = ({
  documents,
  canEdit = false,
  onDelete,
  openInNewTab = true,
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {documents.map((doc) => (
        <div
          key={doc.id}
          className="group relative rounded-xl border bg-background shadow-sm overflow-hidden"
        >
          <button
            type="button"
            onClick={() => {
              if (!doc.document) return;
              if (openInNewTab) {
                window.open(doc.document, '_blank', 'noopener,noreferrer');
              } else {
                window.location.href = doc.document;
              }
            }}
            className="block w-full text-left"
          >
            <div className="aspect-[1.8/1] bg-muted flex items-center justify-center relative">
              {doc.document ? (
                <img
                  src={doc.document}
                  alt={doc.name}
                  className="h-full w-full object-cover"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                  }}
                />
              ) : null}
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <Paperclip className="h-8 w-8 text-muted-foreground/80" />
              </div>
            </div>
            <div className="p-3">
              <p className="text-sm font-medium truncate">{doc.name}</p>
            </div>
          </button>

          {canEdit && onDelete && (
            <button
              type="button"
              onClick={() => onDelete(doc)}
              className="absolute right-2 top-2 inline-flex h-8 w-8 items-center justify-center rounded-full bg-background/90 text-destructive shadow-sm opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity"
              title="Delete document"
            >
              <Trash2 className="h-4 w-4" />
            </button>
          )}
        </div>
      ))}
    </div>
  );
};
